import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import homeReducer from "../features/home/homeSlice";
import userReducer from "../features/home/userSlice";
import annualReducer from "../features/home/annualSlice";
import codeOfConductReducer from "../features/home/codeOfConductSlice";
import recentUpdatesReducer from "../features/home/recentUpdatesSlice";
import messageReducer from "../features/messages/messageSlice";
import counterReducer from "../features/counter/counterSlice";
import epolicyReducer from "../features/ethicspolicies/ethicspolicySlice";
import loginReducer from "../features/login/loginSlice";
import policyDetailsReducer from "../features/ethicspolicydetails/ethicspolicydetailsSlice";
import forgetPassReducer from '../features/forgetPassword/forgetPassSlice'
import verifyOtpSubmitReducer from '../features/forgetPassword/verifyOtpSlice'
import setPasswordReducer from '../features/forgetPassword/setPasswordSlice'
import LearingModuleReducer from '../features/learning/learningModuleSlice'
import CounsellorModuleReducer from '../features/learning/CounsellorSlice'
import AwarenessModuleReducer from '../features/learning/AwarenessSlice'
import DocumentModuleReducer from '../features/learning/DocumentSlice'
import CaptchaReducer from '../features/login/captchSlice'
import CodeOfVoilationModuleRedcuer from '../features/learning/CodeOfVoilationSlice'
import CountryListReducer from '../features/helpandassistance/countryListSlice'
import CompanyListReducer from '../features/helpandassistance/companyListSlice'
import LocationListReducer from '../features/helpandassistance/locationListSlice'
import GiftDeclarationsReducer from '../features/helpandassistance/giftDeclarationsSlice'
import LectureDeclarationsReducer from '../features/helpandassistance/lectureDeclarationsSlice'
import setNewGiftReducer from '../features/helpandassistance/addNewGiftSlice'
import setNewLectureReducer from '../features/helpandassistance/addNewLectureSlice'
import NewmessageReducer from '../features/messages/insertMessageSlice'
import UpdatemessageReducer from '../features/messages/updateMessageSlice'
import DeletemessageReducer from '../features/messages/DeleteMessageSlice'
import GiftLectureSearchReducer from '../features/helpandassistance/searchGiftLectureSlice'
import YearListReducer from '../features/helpandassistance/GetYearSlice'
import InsertMaterialReducer from '../features/learning/insertMaterialSlice'
import UpdateMaterialReducer from '../features/learning/updateMaterialSlice'
import DeleteMaterialReducer from '../features/learning/deleteMaterialSlice'
import CalendarReducer from '../features/learning/ECPCalendarSlice'
import UpdateCalendarReducer from '../features/learning/updateCalenderSlice'
import CounsellorSearch from '../features/helpandassistance/counsellorSearchSlice';
import CounsellorReducer from '../features/helpandassistance/counsellorSlice';
import ContactsReducer from '../features/helpandassistance/contactsSlice';
import InsertCodeVoilationReducer from '../features/learning/InsertCodeVolationSlice'
import DeleteCVCompanyReducer from '../features/learning/deleteCodeVCompanySlice'
import DeleteCVCompanyRecordsReducer from '../features/learning/deleteCompanyRecordsSlice'
import InsertCompanyGroupReducer from '../features/learning/insertCompanyGroupSlice'
import UpdateCompanyGroupReducer from '../features/learning/updateCompanyGroup'
import InsertEthicsTeamGroupReducer from '../features/helpandassistance/insertEthicsTeamGroupSlice'
import DeleteEthicsTeamGroupReducer from '../features/helpandassistance/deleteEthicsTeamGroupSlice'
import InsertEthicsTeamGroupDetailsReducer from '../features/helpandassistance/insertEthicsTeamGroupDetailsSlice'
import DeleteEthicsTeamGroupDetailsReducer from '../features/helpandassistance/deleteEthicsTeamGroupDetailsSlice'
import InsertCounsellorsListReducer from '../features/helpandassistance/insertCounsellorslistSlice'
import DeleteethicsCounsellorReducer from '../features/helpandassistance/deleteethicsCounsellorSlice'
import InsertCounsellorsListDetailsReducer from '../features/helpandassistance/insertCounsellorslistDetailsSlice'
import DeleteethicsCounsellorDetailsReducer from '../features/helpandassistance/deleteethicsCounsellorDetailsSlice'
import UploadFileReducer from '../features/fileUpload/UploadFileSlice'
import BusinessUnitListReducer from '../features/helpandassistance/BusinessUnitSlice'
import SectorListReducer from '../features/helpandassistance/SectorListSLice'
import DocumentHelpModuleReducer from '../features/learning/HelpDocumentSlice'
import ChangePassReducer from '../features/login/ChangePassSlice'
import getLogoutReducer from '../features/login/LogoutSlice'
import InvestigatorModuleReducer from '../features/learning/InvestigatorSlice'
import LogsTrackerReducer from '../features/login/logsTracker'
import RoleListReducer from '../features/rolebase/roleList'
import ModuleListReducer from '../features/rolebase/moduleList'
import UserListReducer from '../features/rolebase/userList'
import UserListExcludedReducer from '../features/rolebase/userListExcluded'
import UpdateRoleReducer from '../features/rolebase/updateRole'
import UserPermisionReducer from '../features/rolebase/userPermissionSlice'
import nonadfsReducer from '../features/company/getNonAdfsSlice'
import allCompanyReducer from '../features/company/companyListSlice'
import InsertCompanyReducer from '../features/company/insertCompanySlice'
import UpdateCompanyReducer from '../features/company/updateCompanySlice'
import DeleteCompanyReducer from '../features/company/deleteCompanySlice'
import InsertPolicyReducer from '../features/ethicspolicies/insertPolicySlice'
import UpdatePolicyReducer from '../features/ethicspolicies/updatePolicySlice'
import DeletePolicyReducer from '../features/ethicspolicies/deletePolicySlice'
import epolicyMriseReducer from '../features/ethicspolicies/getEpolicyMrise'
import AdminListReducer from '../features/rolebase/adminList';
import { categoryReducer } from "../features/learning/CategorySlice";
import DeclarationReducer from '../features/helpandassistance/DeclarationSlice';

export const store = configureStore({
         reducer: {
           home: homeReducer,
           message: messageReducer,
           counter: counterReducer,
           epolicy: epolicyReducer,
           logIn: loginReducer,
           policyDetails: policyDetailsReducer,
           user: userReducer,
           annual: annualReducer,
           codeOfConduct: codeOfConductReducer,
           recentUpdates: recentUpdatesReducer,
           verifyOtp: forgetPassReducer,
           verifyOtpSubmit: verifyOtpSubmitReducer,
           setPassword: setPasswordReducer,
           LearingModule: LearingModuleReducer,
           CounsellorModule: CounsellorModuleReducer,
           AwarenessModule: AwarenessModuleReducer,
           DocumentModule: DocumentModuleReducer,
           DocumentHelpModule: DocumentHelpModuleReducer,
           InvestigatorModule: InvestigatorModuleReducer,
           getCaptcha: CaptchaReducer,
           CodeOfVoilationModule: CodeOfVoilationModuleRedcuer,
           CountryList: CountryListReducer,
           CompanyList: CompanyListReducer,
           LocationList: LocationListReducer,
           GiftDeclarations: GiftDeclarationsReducer,
           LectureDeclarations: LectureDeclarationsReducer,
           setNewGift: setNewGiftReducer,
           setNewLecture: setNewLectureReducer,
           Newmessage: NewmessageReducer,
           Updatemessage: UpdatemessageReducer,
           Deletemessage: DeletemessageReducer,
           GiftLectureSearch: GiftLectureSearchReducer,
           YearList: YearListReducer,
           InsertMaterial: InsertMaterialReducer,
           UpdateMaterial: UpdateMaterialReducer,
           DeleteMaterial: DeleteMaterialReducer,
           Calendar: CalendarReducer,
           UpdateCalendar: UpdateCalendarReducer,
           Counsellor: CounsellorSearch,
           CounsellorReducer: CounsellorReducer,
           ContactsReducer: ContactsReducer,
           InsertCodeVoilation: InsertCodeVoilationReducer,
           DeleteCVCompany: DeleteCVCompanyReducer,
           DeleteCVCompanyRecords: DeleteCVCompanyRecordsReducer,
           InsertCompanyGroup: InsertCompanyGroupReducer,
           UpdateCompanyGroup: UpdateCompanyGroupReducer,
           InsertEthicsTeamGroup: InsertEthicsTeamGroupReducer,
           DeleteEthicsTeamGroup: DeleteEthicsTeamGroupReducer,
           InsertEthicsTeamGroupDetails: InsertEthicsTeamGroupDetailsReducer,
           DeleteEthicsTeamGroupDetails: DeleteEthicsTeamGroupDetailsReducer,
           DeleteethicsCounsellor: DeleteethicsCounsellorReducer,
           InsertCounsellorsList: InsertCounsellorsListReducer,
           InsertCounsellorsListDetails: InsertCounsellorsListDetailsReducer,
           DeleteethicsCounsellorDetails: DeleteethicsCounsellorDetailsReducer,
           UploadFile: UploadFileReducer,
           BusinessUnitList: BusinessUnitListReducer,
           SectorList: SectorListReducer,
           ChangePass: ChangePassReducer,
           getLogout: getLogoutReducer,
           LogsTracker: LogsTrackerReducer,
           RoleList: RoleListReducer,
           ModuleList: ModuleListReducer,
           UserList: UserListReducer,
           UserListExcluded: UserListExcludedReducer,
           UpdateRole: UpdateRoleReducer,
           UserPermision: UserPermisionReducer,
           nonAdfs: nonadfsReducer,
           allCompany: allCompanyReducer,
           InsertCompany: InsertCompanyReducer,
           UpdateCompany: UpdateCompanyReducer,
           DeleteCompany: DeleteCompanyReducer,
           InsertPolicy: InsertPolicyReducer,
           UpdatePolicy: UpdatePolicyReducer,
           DeletePolicy: DeletePolicyReducer,
           epolicyMrise: epolicyMriseReducer,
           AdminList: AdminListReducer,
           category: categoryReducer,
           declaration: DeclarationReducer,
         }
       });

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
